import * as React from "react";
const SvgCopy = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 16H10V4H17L20 7V16ZM5.5 8H9V9.5H5.5V18.5H12.5V17H14V18.5V20H12.5H5.5H4V18.5V9.5V8H5.5Z", fill: "currentColor" }));
export default SvgCopy;
